enum VirtualMeetingtypeParentEnum {
  Others = 0,
  YouTubeOrVimeo = 1,
  ConferenceSoftware = 2,
  MeetAppLive = 3,
  ProfessionalStreaming = 4,
  PreRecordedVideo = 5,
}
export default Object.freeze(VirtualMeetingtypeParentEnum);
